import * as React from "react";

import { I18n } from "./I18n";
import { DeleteIcon } from "./Icons";
import { GenericModal } from "../utils/GenericModal";

class DeleteConfirmationProps {
    onConfirm: () => void;
    onCancelDelete: () => void;
    deleteConfirmBody?: string | null;
}

export function DeleteModal(props: DeleteConfirmationProps): JSX.Element {
    const bodyText = props.deleteConfirmBody != null
        ? props.deleteConfirmBody
        : I18n.Strings.deleteConfirmBody;

    return (
        <GenericModal
            title={I18n.Strings.deleteConfirmTitle}
            body={bodyText}
            onClose={() => props.onCancelDelete()}
            onOk={() => props.onConfirm()}
            okText={I18n.Strings.delete}
            okIcon={<DeleteIcon />}
            cancelText={I18n.Strings.cancel}
        />
    );
}
